// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"434d5a08","615":"12dc2e4d"}[chunkId] + ".chunk.css";
};